import { gql } from 'apollo-angular';
import { ContractedParties } from 'app/modules/contract-view/components/models/contracted-parties.model';

export const GET_PARENT_CONTROL_TOWER_ID_AND_CONTRACT_PARTIES_BY_CONTROL_TOWER_ID = gql`
  query GetParentControlTowerIdAndContractPartiesByControlTowerId($controlTowerId: String!) {
    contract: getSmartContractByControlTowerId(controlTowerId: $controlTowerId) {
      _id
      parentControlTowerId
      contractType
      parties {
        buyer {
          partyId
          jobFileInfo {
            jobRefId
          }
        }
        seller {
          partyId
          jobFileInfo {
            jobRefId
          }
        }
        others {
          partyId
        }
        fourPL {
          partyId
        }
      }
    }
  }
`;

export interface GetParentControlTowerIdAndContractPartiesByControlTowerIdResponse {
  contract: {
    _id: string;
    parentControlTowerId: string;
    parties: ContractedParties;
    contractType?: string;
  };
}
